import React, { useEffect } from 'react';
import FormationAddPhoto from '../images/FormationAdd.png';
import FormationEditPhoto from '../images/FormationEdit.png';
import FormationRemoveOnePhoto from '../images/FormationRemoveOne.png';
import FormationRemoveAllPhoto from '../images/FormationRemoveAll.png';
import styled from 'styled-components';

const StyledContainer = styled.div`
width: 100%;
margin: auto;
padding: 10px 0px 10px 0px;
`;

const FormationPage = (props) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div style={{ fontSize: "18px" }}>
        <div style={{ fontSize: "32px", fontWeight: "bold", marginTop: '10px'}}>
        Formation
        </div>
        <div style={{ margin: '10px 0px' }}>
        To add Formation, right click <strong>Project</strong> node, then click <strong>Add Formation</strong> menu. In <strong>Add Formation</strong> dialog, 
        enter Formation name, select a color, check Wireframe checkbox (Checked for wireframe formation, Unchecked for solid formation), and enter Vertices, then click <strong>OK</strong>.
        </div>
        <div style={{ margin: '10px 0px' }}>
        Vertice's data format is Latitude, Logitude, Elevation. Each vertice is in a line. 
        </div>

        <StyledContainer>
            <img src={FormationAddPhoto} style={{width: '100%', height: 'auto', border: '1px solid gray'}} alt="" />
        </StyledContainer>

        <div style={{ margin: '10px 0px' }}>
        After Formation added, to add another Formation, right click <strong>Project</strong> node, then click <strong>Add Formation</strong> menu, 
        or right click <strong>Formations</strong> node, then click <strong>Add Formation</strong> menu.
        </div>

        <StyledContainer>
            {/* <img src={FormationAddPhoto2} style={{width: '100%', height: 'auto', border: '1px solid gray'}} alt="" /> */}
        </StyledContainer>

        <div style={{ margin: '10px 0px' }}>
        To edit a Formation, right click Formation node you want to edit, then click <strong>Edit This Formation</strong> menu.
        </div>

        <StyledContainer>
            <img src={FormationEditPhoto} style={{width: '100%', height: 'auto', border: '1px solid gray'}} alt="" />
        </StyledContainer>

        <div style={{ margin: '10px 0px' }}>
        To remove a Formation, right click Formation node you want to remove, then click <strong>Remove This Formation</strong> menu.
        </div>
        <StyledContainer>
            <img src={FormationRemoveOnePhoto} style={{width: '100%', height: 'auto', border: '1px solid gray'}} alt="" />
        </StyledContainer>

        <div style={{ margin: '10px 0px' }}>
        To remove all of Formations, right click <strong>Formation Group</strong> node, then click <strong>Remove All Formations</strong> menu.
        </div>
        <StyledContainer>
            <img src={FormationRemoveAllPhoto} style={{width: '100%', height: 'auto', border: '1px solid gray'}} alt="" />
        </StyledContainer>
    </div>
  )
}

export default FormationPage;